/* Chargement infini des collections (section Collection > Pagination = « Chargement infini »).
   On réutilise le bouton « Afficher plus » du thème (#load-more-button[data-infinite]) : il est
   déclenché automatiquement à l'approche du bas de page, et le thème (custom-async.js) fait le
   reste : fetch de la page suivante (filtres et tri conservés dans l'URL), ajout des produits,
   remplacement du bouton, ré-initialisation quick shop / panier / variantes.
   - data-infinite-max = nombre de chargements automatiques avant de réafficher le bouton
     (0 = illimité, aucun clic). Un clic sur le bouton relance une nouvelle série.
   - Les produits mis en avant (collection-bohm.js, remontés en tête de page 1) ne sont pas
     répétés quand ils réapparaissent dans les pages suivantes. */
(function () {
  if (window.__bohmInfiniteScroll) return;
  window.__bohmInfiniteScroll = true;

  var BUTTON = '#load-more-button[data-infinite][data-next]';
  var RETRY_DELAY = 300;
  var observed = null;

  // custom-async.js (qui branche le clic du bouton) n'est chargé qu'à la première interaction :
  // tant qu'il n'est pas prêt, un clic suivrait le lien et rechargerait la page.
  function themeReady() {
    return typeof window.quickShop !== 'undefined';
  }

  function getList() {
    return document.getElementById('collection');
  }

  function autoAllowed(btn) {
    var max = parseInt(btn.getAttribute('data-infinite-max'), 10) || 0;
    if (!max) return true;
    var list = getList();
    return !list || (list.__infiniteLoads || 0) < max;
  }

  function ensureLoader(container) {
    if (container.querySelector('.infinite-loader')) return;
    var loader = document.createElement('span');
    loader.className = 'infinite-loader';
    loader.setAttribute('aria-hidden', 'true');
    container.appendChild(loader);
  }

  function trigger(btn) {
    if (!btn.isConnected || !btn.__infiniteInView) return;
    if (btn.classList.contains('loading') || !autoAllowed(btn)) return;

    if (!themeReady()) {
      setTimeout(function () { trigger(btn); }, RETRY_DELAY);
      return;
    }

    var list = getList();
    if (list) list.__infiniteLoads = (list.__infiniteLoads || 0) + 1;
    btn.click();
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.__infiniteInView = entry.isIntersecting;
      if (entry.isIntersecting) trigger(entry.target);
    });
  }, { rootMargin: '0px 0px 800px 0px' });

  function dedupe() {
    var list = getList();
    if (!list) return;
    var seen = {};
    Array.prototype.forEach.call(list.querySelectorAll(':scope > li[data-product-id]'), function (li) {
      var id = li.getAttribute('data-product-id');
      if (seen[id]) li.parentNode.removeChild(li);
      else seen[id] = true;
    });
  }

  function refresh() {
    dedupe();

    var btn = document.querySelector(BUTTON);

    // Mode automatique : bouton masqué, loader affiché. Sinon le bouton redevient cliquable.
    Array.prototype.forEach.call(document.querySelectorAll('.link-btn.infinite-auto'), function (p) {
      if (!btn || p !== btn.parentNode) p.classList.remove('infinite-auto');
    });
    if (btn && btn.parentNode) {
      ensureLoader(btn.parentNode);
      btn.parentNode.classList.toggle('infinite-auto', autoAllowed(btn));
    }

    if (btn !== observed) {
      if (observed) io.unobserve(observed);
      observed = btn;
      if (btn) io.observe(btn);
    }
  }

  // Un clic manuel (bouton réaffiché après N chargements) relance une série automatique.
  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target.closest(BUTTON)) return;
    var list = getList();
    if (list) list.__infiniteLoads = 0;
  }, true);

  // Pages suivantes, filtres (section re-rendue en AJAX), mise en avant… : on se recale.
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      refresh();
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
